/**
 * Export a list on screen as a spreadsheet (Liezel, 5 Nov 2026: "extract
 * matters spreadsheets, eg pipeline with stages, open matters").
 *
 * The file is built in the browser from the rows the page already shows,
 * after its own filters and sort. Nothing is fetched, so a download can
 * never hold a matter the person could not already see on screen.
 *
 * It writes CSV with a UTF-8 byte order mark, which Excel opens directly
 * and which keeps "£" and accented names intact.
 *
 * columns: [{ header: "Matter Ref", value: (row) => row.matter_ref }, ...]
 */

// A cell that starts with one of these is read by Excel as a formula. A
// client name or note typed as "=HYPERLINK(...)" must stay text.
const FORMULA_LEAD = /^[=+\-@\t\r]/;

export function csvCell(value) {
  if (value === null || value === undefined) return "";
  let s = typeof value === "number" ? String(value) : String(value);
  if (typeof value !== "number" && FORMULA_LEAD.test(s)) s = `'${s}`;
  if (/[",\r\n]/.test(s) || s !== s.trim()) s = `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCsv(columns, rows) {
  const lines = [columns.map((c) => csvCell(c.header)).join(",")];
  for (const row of rows || []) {
    lines.push(columns.map((c) => {
      let v;
      try { v = c.value(row); } catch { v = ""; }
      return csvCell(v);
    }).join(","));
  }
  return lines.join("\r\n");
}

/** dd/mm/yyyy, which UK Excel reads as a date. Blank for no date. */
export function sheetDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return String(d);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(dt.getDate())}/${p(dt.getMonth() + 1)}/${dt.getFullYear()}`;
}

/** "open-matters-05Nov2026.csv" */
export function exportFileName(stem, now = new Date()) {
  const mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][now.getMonth()];
  return `${stem}-${String(now.getDate()).padStart(2, "0")}${mon}${now.getFullYear()}.csv`;
}

export function downloadSpreadsheet(stem, columns, rows) {
  const csv = "﻿" + toCsv(columns, rows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = exportFileName(stem);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
